import { useMemo } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import styles from './CommentInputBox.styles';

interface CommentInputBoxComponentProps {
  handleChangeComment: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handlePostComment: (comment?: string) => void;
  handleSetFocus: () => void;
  customRef?: React.MutableRefObject<any>;
  wasFocused?: boolean;
  isFeedback?: boolean;
  comment?: string;
}

const CommentInputBoxComponent = function ({
  handleChangeComment,
  handlePostComment,
  handleSetFocus,
  customRef,
  wasFocused = false,
  isFeedback,
  comment,
}: CommentInputBoxComponentProps): JSX.Element {
  const labelInput = useMemo(() => {
    if (isFeedback) return 'Add a feedback';
    return 'Add a comment';
  }, [isFeedback]);

  const labelButton = useMemo(() => {
    if (isFeedback) return 'Post feedback';
    return 'Post comment';
  }, [isFeedback]);

  return (
    <>
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'normal' }}
        marginBottom={wasFocused ? 0 : 2}
        data-testid="comment-input-box"
      >
        <Box sx={{ width: '100%' }} display="flex" flex={1}>
          <TextField
            inputRef={customRef}
            value={comment}
            onChange={handleChangeComment}
            autoFocus={wasFocused}
            onFocus={handleSetFocus}
            sx={styles.textField}
            size="small"
            multiline
            variant="outlined"
            label={labelInput}
            fullWidth
            data-testid="comment-input"
          />
        </Box>

        {wasFocused && (
          <Box
            display="flex"
            marginLeft={{ xs: 0, sm: 1 }}
            marginTop={{ xs: 1, sm: 0 }}
            justifyContent="flex-end"
          >
            <Button
              variant="outlined"
              onClick={() => handlePostComment(comment)}
              data-testid="comment-input-button"
            >
              {labelButton}
            </Button>
          </Box>
        )}
      </Box>

      {wasFocused && (
        <Typography variant="subtitle1" marginY={1}>
          Click on {labelButton} to save the comment
        </Typography>
      )}
    </>
  );
};

export default CommentInputBoxComponent;
